export const environment = {
  production: false,
  datadropApiUrl: '',
  numberItemsInPage: 100,
  s3BucketName: '',
  s3IngestionBucketName: '',
};

function getDataSynchronous(cb) {
  const url = "../assets/jsons/config.json";
  const request = new XMLHttpRequest();
  const isKarma = typeof window !== 'undefined' && !!(window as any).__karma__;

  try {
    request.open('GET', url, false);
    request.send();

    if (request.status === 200) {
      return cb(JSON.parse(request.response));
    }
  } catch (error) {
    if (!isKarma) {
      throw error;
    }
  }

  if (isKarma) {
    return cb({ apiUrl: '' });
  }

  throw new Error('request CONFIG.JSON failed');
}

getDataSynchronous((config) => {
  environment.datadropApiUrl = config.apiUrl;
  environment.s3BucketName = config.s3BucketName || 'ratings-datastore-test-use';
});